import React, { useState } from 'react';
import { seoFaqs } from '../data/faqs';

function ChevronIcon({ open }) {
  return (
    <span className={`faq-card__icon-wrap${open ? ' faq-card__icon-wrap--open' : ''}`} aria-hidden>
      <svg className="faq-card__icon-svg" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M6 9l6 6 6-6"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState(-1);

  return (
    <section className="section faq-section" id="faq" aria-labelledby="faq-heading">
      <div className="faq-section__glow" aria-hidden />
      <div className="container faq-section__inner">
        <header className="faq-section__intro">
          <p className="faq-section__eyebrow">Help center</p>
          <h2 id="faq-heading" className="faq-section__title">
            Questions, answered
          </h2>
          <p className="faq-section__lede">
            Straightforward guidance on Notrack, Indian meals, and sustainable weight loss—without the spreadsheet.
          </p>
          <p className="faq-section__hint">
            <span className="faq-section__hint-dot" aria-hidden />
            Tap any card to expand
          </p>
        </header>

        <div className="faq-section__list" role="list">
          {seoFaqs.map((f, idx) => {
            const open = openIndex === idx;
            const panelId = `faq-panel-${idx}`;
            const triggerId = `faq-trigger-${idx}`;
            const n = String(idx + 1).padStart(2, '0');
            return (
              <article key={f.q} className={`faq-card${open ? ' faq-card--open' : ''}`} role="listitem">
                <h3 className="faq-card__heading">
                  <button
                    type="button"
                    id={triggerId}
                    className="faq-card__trigger"
                    aria-expanded={open}
                    aria-controls={panelId}
                    onClick={() => setOpenIndex(open ? -1 : idx)}
                  >
                    <span className="faq-card__meta">
                      <span className="faq-card__index">{n}</span>
                      <span className="faq-card__question">{f.q}</span>
                    </span>
                    <ChevronIcon open={open} />
                  </button>
                </h3>
                <div id={panelId} role="region" className="faq-card__panel" aria-labelledby={triggerId}>
                  <div className="faq-card__panel-inner">
                    <div className="faq-card__answer">
                      <p className="faq-card__answer-text">{f.a}</p>
                    </div>
                  </div>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
